import PageHero from "../components/sections/PageHero";
import GoldButton from "../components/ui/GoldButton";
import SectionLabel from "../components/ui/SectionLabel";

const Uae = () => (
  <>
    <PageHero
      label="UAE"
      title="UAE's Indian-origin"
      titleAccent="technology partner."
      subtitle="Full-stack technology and AI for UAE businesses. Billed in AED. Delivered to your timezone."
    />

    <section style={{ background: "#050505", padding: "0 0 120px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 24,
            marginBottom: 48,
          }}
        >
          <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="VALUE" />
            <p style={{ marginTop: 18, fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#F8F4EC", lineHeight: 1.8 }}>
              Same software Dubai agencies quote at AED 150,000 — we deliver at a fraction of the cost. 60% of UAE businesses are Indian-owned or managed.
            </p>
          </div>
          <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="COMPLIANCE" />
            <p style={{ marginTop: 18, fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#F8F4EC", lineHeight: 1.8 }}>
              VAT-compliant invoicing · Arabic language support · UAE data residency · PayTabs/Telr/Stripe UAE
            </p>
          </div>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 42 }}>
          {["Dubai (primary)", "Abu Dhabi", "Sharjah / Northern Emirates"].map((city) => (
            <span key={city} style={{ padding: "9px 14px", border: "1px solid rgba(212,168,67,0.24)", borderRadius: 3, fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#D4A843", background: "rgba(212,168,67,0.06)" }}>
              {city}
            </span>
          ))}
        </div>

        <div style={{ textAlign: "center" }}>
          <GoldButton href="/contact">START A UAE PROJECT</GoldButton>
        </div>
      </div>
    </section>
  </>
);

export default Uae;
